
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {
  @Prop({ required: true })
  private isLoading!: boolean;

  @Prop()
  private progress?: boolean;
}
